const headlineCards = [
  {
    company: 'KC',
    title: 'Sales Trends',
    body:
      'KC is seeing growth driven by all sectors, <span style="color: #00A064">primarily Facial Cleansing.<span>',
  },
  {
    company: 'KC',
    title: 'Share Trends',
    body:
      'Share loss is driven by Baby Care <span style="color: #D8001A">-5.7%</span>, Fem Care <span style="color: #D8001A">-8.4%</span>, and Fam Care <span style="color: #D8001A">-8.3%</span>',
  },
  {
    company: 'MARKET',
    title: 'Strong movement',
    body:
      'Category sales showing strong groowth <span style="color: #00A064">(+46.7%)</span>',
  },
  {
    company: 'MARKET',
    title: 'Strong movement',
    body:
      'P&G seeing significant sales growth of <span style="color: #00A064">+96.5%</span>',
  },
  {
    company: 'MARKET',
    title: 'New player',
    body:
      'iPlay has entered the market with a <span style="color: #00A064">5.6% share gain</span>',
  },
];

const watchListCards = [
  {
    company: 'Pampers',
    companyLogo:
      'https://theglobalfacts.com/wp-content/uploads/2019/09/PG_logo-min.png',
    totalNumber: '$64.361M',
    totalNumberYoY: -8.2,
    totalPercentage: '20.4%',
    totalPercentageYoY: -3.2,
  },
  {
    company: 'iPlay Diapers',
    companyLogo:
      'https://cdn.shopify.com/s/files/1/0095/4132/0764/files/Centered_Logo_800x195.png?v=1581970839',
    totalNumber: '$64.361M',
    totalNumberYoY: 19.2,
    totalPercentage: '20.4%',
    totalPercentageYoY: -3.2,
  },
  {
    company: 'Quilted Northern',
    companyLogo:
      'https://upload.wikimedia.org/wikipedia/en/thumb/6/6a/Georgia-Pacific_logo.svg/1200px-Georgia-Pacific_logo.svg.png',
    totalNumber: '$2.599M',
    totalNumberYoY: -8.2,
    totalPercentage: '7.4%',
    totalPercentageYoY: -3.2,
  },
];

const topPerformersCards = [
  {
    company: 'Huggies',
    companyLogo: 'https://www.huggies.com/Content/img/Android_App_Icon.png',
    totalNumber: '$64.361M',
    totalNumberYoY: -8.2,
    totalPercentage: 20.4,
    totalPercentageYoY: -3.2,
  },
  {
    company: 'Kleenex',
    companyLogo:
      'https://upload.wikimedia.org/wikipedia/sco/thumb/0/07/Kleenex_logo_new.svg/1200px-Kleenex_logo_new.svg.png',
    totalNumber: '$64.361M',
    totalNumberYoY: 19.2,
    totalPercentage: 20.4,
    totalPercentageYoY: -3.2,
  },
  {
    company: 'Kotex',
    companyLogo:
      'https://logoeps.com/wp-content/uploads/2012/05/kotex-logo-vector-01.png',
    totalNumber: '$2.599M',
    totalNumberYoY: -8.2,
    totalPercentage: 7.7,
    totalPercentageYoY: -3.2,
  },
  {
    company: 'Cottonelle',
    companyLogo: 'https://logodix.com/logo/1775038.png',
    totalNumber: '$2.599M',
    totalNumberYoY: -8.2,
    totalPercentage: 7.7,
    totalPercentageYoY: -3.2,
  },
];

const heroSeries = [
  {
    data: [30, 40, 45, 50, 49, 60, 70, 51],
  },
];

const mySalesSeries = [
  {
    data: [85, 74, 70, 75, 75, 90, 95, 101, 87, 93, 91, 85],
  },
  {
    data: [65, 65, 70, 70, 72, 75, 70, 72, 79, 73, 80, 75],
  },
  {
    data: [35, 44, 50, 55, 55, 60, 65, 55, 44, 35, 44, 55],
  },
  {
    data: [30, 25, 30, 40, 45, 50, 60, 70, 60, 65, 63, 62],
  },
];

const monthDateRange = [
  'Apr 7th 2019 - May 4th 2019',
  'May 5th 2019 - Jun 1st 2019',
  'Jun 2nd 2019 - Jun 29th 2019',
  'Jun 30th 2019 - Aug 3rd 2019',
  'Aug 4th 2019 - Aug 31st 2019',
  'Sep 1st 2019 - Sep 28th 2019',
  'Sep 29th 2019 - Nov 2nd 2019',
  'Nov 3rd 2019 - Nov 30th 2019',
  'Dec 1st 2019 - Dec 28th 2019',
  'Dec 29th 2019 - Feb 1st 2020',
  'Feb 2nd 2020 - Feb 29th 2020',
  'Mar 1st 2020 - Mar 28th 2020',
];

const weekDateRange = [
  'March 28th 2020 - April 4th 2020',
  'April 5th 2020 - April 12th 2020',
  'April 13th 2020 - April 20th 2020',
  'April 21st 2020 - April 28th 2020',
  'April 29th 2020 - May 6th 2020',
  'May 7th 2020 - May 14th 2020',
  'May 15th 2020 - May 22nd 2020',
  'May 23rd 2020 - May 30th 2020',
  'May 31st 2020 - Jun 7th 2020',
  'Jun 8th 2020 - Jun 15th 2020',
  'Jun 16th 2020 - Jun 23st 2020',
  'Jun 24th 2020 - Jul 1st 2020',
];

const mySalesTable = [
  [
    {
      title: 'Total',
      value: 134.361,
      percentChange: 12.7,
    },
    {
      title: 'Adult Incontinence',
      value: 35.272,
      percentChange: 12.1,
    },
    {
      title: 'Baby & Childcare',
      value: 39.199,
      percentChange: 11.4,
    },
    {
      title: 'Compromisedskin',
      value: 15.225,
      percentChange: -2.1,
    },
    {
      title: 'Digestive Health',
      value: 0.214,
      percentChange: 32.1,
    },
  ],
  [
    {
      title: 'Total',
      value: 110.163,
      percentChange: 12.1,
    },
    {
      title: 'Adult Incontinence',
      value: 42.393,
      percentChange: 12.2,
    },
    {
      title: 'Baby & Childcare',
      value: 33.19,
      percentChange: 11.5,
    },
    {
      title: 'Compromisedskin',
      value: 14.982,
      percentChange: -4.3,
    },
    {
      title: 'Digestive Health',
      value: 0.29,
      percentChange: 220.1,
    },
  ],
  [
    {
      title: 'Total',
      value: 105.132,
      percentChange: 14.4,
    },
    {
      title: 'Adult Incontinence',
      value: 52.11,
      percentChange: 14.5,
    },
    {
      title: 'Baby & Childcare',
      value: 40.832,
      percentChange: 18.5,
    },
    {
      title: 'Compromisedskin',
      value: 13.211,
      percentChange: -4.3,
    },
    {
      title: 'Digestive Health',
      value: 1.5,
      percentChange: -32.1,
    },
  ],
  [
    {
      title: 'Total',
      value: 127.362,
      percentChange: 13.4,
    },
    {
      title: 'Adult Incontinence',
      value: 41.17,
      percentChange: -14.5,
    },
    {
      title: 'Baby & Childcare',
      value: 39.099,
      percentChange: 19.2,
    },
    {
      title: 'Compromisedskin',
      value: 14.141,
      percentChange: -4.3,
    },
    {
      title: 'Digestive Health',
      value: 0.432,
      percentChange: 40.1,
    },
  ],
  [
    {
      title: 'Total',
      value: 99.361,
      percentChange: -9.4,
    },
    {
      title: 'Adult Incontinence',
      value: 54.272,
      percentChange: 14.5,
    },
    {
      title: 'Baby & Childcare',
      value: 38.209,
      percentChange: 0.5,
    },
    {
      title: 'Compromisedskin',
      value: 16.021,
      percentChange: -4.3,
    },
    {
      title: 'Digestive Health',
      value: 0.75,
      percentChange: 32.1,
    },
  ],
  [
    {
      title: 'Total',
      value: 120.312,
      percentChange: 16.4,
    },
    {
      title: 'Adult Incontinence',
      value: 33.272,
      percentChange: -14.5,
    },
    {
      title: 'Baby & Childcare',
      value: 48.039,
      percentChange: 10.5,
    },
    {
      title: 'Compromisedskin',
      value: 18.522,
      percentChange: 2.3,
    },
    {
      title: 'Digestive Health',
      value: 0.52,
      percentChange: 0.1,
    },
  ],
  [
    {
      title: 'Total',
      value: 153.361,
      percentChange: 14.4,
    },
    {
      title: 'Adult Incontinence',
      value: 63.001,
      percentChange: 25.5,
    },
    {
      title: 'Baby & Childcare',
      value: 39.299,
      percentChange: 1.5,
    },
    {
      title: 'Compromisedskin',
      value: 19.255,
      percentChange: -2.3,
    },
    {
      title: 'Digestive Health',
      value: 0.203,
      percentChange: -50.1,
    },
  ],
  [
    {
      title: 'Total',
      value: 99.361,
      percentChange: -10.4,
    },
    {
      title: 'Adult Incontinence',
      value: 43.272,
      percentChange: 14.9,
    },
    {
      title: 'Baby & Childcare',
      value: 32.123,
      percentChange: 15.5,
    },
    {
      title: 'Compromisedskin',
      value: 12.992,
      percentChange: -8.3,
    },
    {
      title: 'Digestive Health',
      value: 0.991,
      percentChange: 40.1,
    },
  ],
  [
    {
      title: 'Total',
      value: 103.923,
      percentChange: 4.4,
    },
    {
      title: 'Adult Incontinence',
      value: 65.921,
      percentChange: 20.5,
    },
    {
      title: 'Baby & Childcare',
      value: 41.299,
      percentChange: 3.5,
    },
    {
      title: 'Compromisedskin',
      value: 19.522,
      percentChange: -3.3,
    },
    {
      title: 'Digestive Health',
      value: 5.532,
      percentChange: 421.1,
    },
  ],
  [
    {
      title: 'Total',
      value: 83.192,
      percentChange: -10.9,
    },
    {
      title: 'Adult Incontinence',
      value: 39.272,
      percentChange: -5.5,
    },
    {
      title: 'Baby & Childcare',
      value: 27.341,
      percentChange: -18.5,
    },
    {
      title: 'Compromisedskin',
      value: 15.427,
      percentChange: -4.3,
    },
    {
      title: 'Digestive Health',
      value: 0.12,
      percentChange: -32.1,
    },
  ],
  [
    {
      title: 'Total',
      value: 102.392,
      percentChange: 14.4,
    },
    {
      title: 'Adult Incontinence',
      value: 45.272,
      percentChange: 14.5,
    },
    {
      title: 'Baby & Childcare',
      value: 38.299,
      percentChange: 18.5,
    },
    {
      title: 'Compromisedskin',
      value: 17.522,
      percentChange: -4.3,
    },
    {
      title: 'Digestive Health',
      value: 0.521,
      percentChange: 32.1,
    },
  ],
  [
    {
      title: 'Total',
      value: 108.361,
      percentChange: 14.4,
    },
    {
      title: 'Adult Incontinence',
      value: 45.272,
      percentChange: 14.5,
    },
    {
      title: 'Baby & Childcare',
      value: 38.299,
      percentChange: 18.5,
    },
    {
      title: 'Compromisedskin',
      value: 17.522,
      percentChange: -4.3,
    },
    {
      title: 'Digestive Health',
      value: 0.521,
      percentChange: 32.1,
    },
  ],
];

const myShareSeries = [
  {
    data: [85, 74, 70, 75, 75, 90, 95, 93, 97, 95, 91, 85],
  },
  {
    data: [65, 65, 70, 70, 72, 75, 70, 70, 71, 72, 80, 74],
  },
  {
    data: [35, 44, 50, 55, 55, 60, 65, 60, 55, 55, 67, 70],
  },
  {
    data: [30, 25, 30, 40, 45, 50, 60, 45, 55, 53, 60, 65],
  },
];

const myShareTable = [
  [
    {
      title: 'Adult Incontinence',
      value: 24.1,
      percentChange: -4.6,
    },
    {
      title: 'Baby & Childcare',
      value: 25.4,
      percentChange: -7.1,
    },
    {
      title: 'Compromisedskin',
      value: 25.7,
      percentChange: -6.4,
    },
    {
      title: 'Digestive Health',
      value: 0.5,
      percentChange: 3.1,
    },
  ],
  [
    {
      title: 'Adult Incontinence',
      value: 25.2,
      percentChange: 1.7,
    },
    {
      title: 'Baby & Childcare',
      value: 30.5,
      percentChange: 2.3,
    },
    {
      title: 'Compromisedskin',
      value: 20.2,
      percentChange: -5.4,
    },
    {
      title: 'Digestive Health',
      value: 1.5,
      percentChange: 32.1,
    },
  ],
  [
    {
      title: 'Adult Incontinence',
      value: 24.9,
      percentChange: -5.5,
    },
    {
      title: 'Baby & Childcare',
      value: 27.5,
      percentChange: -8.4,
    },
    {
      title: 'Compromisedskin',
      value: 20.7,
      percentChange: -8.2,
    },
    {
      title: 'Digestive Health',
      value: 0.6,
      percentChange: -31.9,
    },
  ],
  [
    {
      title: 'Adult Incontinence',
      value: 23.1,
      percentChange: -1.7,
    },
    {
      title: 'Baby & Childcare',
      value: 26.5,
      percentChange: 1.3,
    },
    {
      title: 'Compromisedskin',
      value: 29.7,
      percentChange: 4.4,
    },
    {
      title: 'Digestive Health',
      value: 0.7,
      percentChange: 0.1,
    },
  ],
  [
    {
      title: 'Adult Incontinence',
      value: 23.5,
      percentChange: -3.6,
    },
    {
      title: 'Baby & Childcare',
      value: 25.5,
      percentChange: -9.3,
    },
    {
      title: 'Compromisedskin',
      value: 24.7,
      percentChange: -5.0,
    },
    {
      title: 'Digestive Health',
      value: 0.5,
      percentChange: 0.0,
    },
  ],
  [
    {
      title: 'Adult Incontinence',
      value: 23.5,
      percentChange: 0.0,
    },
    {
      title: 'Baby & Childcare',
      value: 23.1,
      percentChange: -2.3,
    },
    {
      title: 'Compromisedskin',
      value: 27.7,
      percentChange: 0.4,
    },
    {
      title: 'Digestive Health',
      value: 0.8,
      percentChange: 3.1,
    },
  ],
  [
    {
      title: 'Adult Incontinence',
      value: 30.1,
      percentChange: 5.7,
    },
    {
      title: 'Baby & Childcare',
      value: 29.4,
      percentChange: 8.1,
    },
    {
      title: 'Compromisedskin',
      value: 23.7,
      percentChange: -4.3,
    },
    {
      title: 'Digestive Health',
      value: 0.9,
      percentChange: 1.1,
    },
  ],
  [
    {
      title: 'Adult Incontinence',
      value: 23.3,
      percentChange: -5.6,
    },
    {
      title: 'Baby & Childcare',
      value: 22.5,
      percentChange: -8.1,
    },
    {
      title: 'Compromisedskin',
      value: 21.7,
      percentChange: -8.3,
    },
    {
      title: 'Digestive Health',
      value: 0.4,
      percentChange: -28.1,
    },
  ],
  [
    {
      title: 'Adult Incontinence',
      value: 29.4,
      percentChange: 1.5,
    },
    {
      title: 'Baby & Childcare',
      value: 32.5,
      percentChange: 5.3,
    },
    {
      title: 'Compromisedskin',
      value: 32.7,
      percentChange: 3.4,
    },
    {
      title: 'Digestive Health',
      value: 0.4,
      percentChange: -10.1,
    },
  ],
  [
    {
      title: 'Adult Incontinence',
      value: 32.7,
      percentChange: 5.3,
    },
    {
      title: 'Baby & Childcare',
      value: 23.5,
      percentChange: -3.3,
    },
    {
      title: 'Compromisedskin',
      value: 24.7,
      percentChange: -10.4,
    },
    {
      title: 'Digestive Health',
      value: 1.1,
      percentChange: 37.3,
    },
  ],
  [
    {
      title: 'Adult Incontinence',
      value: 28.7,
      percentChange: -1.7,
    },
    {
      title: 'Baby & Childcare',
      value: 27.1,
      percentChange: 0.3,
    },
    {
      title: 'Compromisedskin',
      value: 30.4,
      percentChange: 4.4,
    },
    {
      title: 'Digestive Health',
      value: 0.9,
      percentChange: 0.1,
    },
  ],
  [
    {
      title: 'Adult Incontinence',
      value: 32.9,
      percentChange: 5.7,
    },
    {
      title: 'Baby & Childcare',
      value: 35.5,
      percentChange: 8.3,
    },
    {
      title: 'Compromisedskin',
      value: 33.7,
      percentChange: 8.4,
    },
    {
      title: 'Digestive Health',
      value: 0.5,
      percentChange: 32.1,
    },
  ],
];

const indexTrendSeries = [
  {
    data: [100, 95, 90, 90, 90, 95, 95],
  },
  {
    data: [100, 90, 92, 90, 80, 70, 75],
  },
  {
    data: [100, 95, 85, 90, 70, 65, 70],
  },
  {
    data: [100, 90, 50, 60, 60, 85, 90],
  },
  {
    data: [100, 95, 40, 45, 50, 80, 90],
  },
];

const indexTrendTable = [
  {
    title: 'Sales',
    value: '$10.314M',
    percentChange: -17.9,
  },
  {
    title: 'Conversion',
    value: '30.8%',
    percentChange: -3.9,
  },
  {
    title: 'Traffic',
    value: '1.723M Views',
    percentChange: -6.5,
  },
  {
    title: 'Share',
    value: '17.5%',
    percentChange: -10.6,
  },
];

const marketSalesSeries = [
  {
    data: [85, 74, 70, 75, 75, 90, 95],
  },
  {
    data: [65, 65, 70, 70, 72, 75, 70],
  },
  {
    data: [35, 44, 50, 55, 55, 60, 65],
  },
  {
    data: [30, 25, 30, 40, 45, 50, 60],
  },
  {
    data: [10, 10, 15, 20, 15, 50, 60],
  },
];

const marketSalesTable = [
  {
    title: 'Total',
    value: 46.145,
    percentChange: 46.7,
  },
  {
    title: 'P&G',
    value: 14.585,
    percentChange: 96.5,
  },
  {
    title: 'Kimberly Clark',
    value: 10.314,
    percentChange: 7.3,
  },
  {
    title: 'Amazon',
    value: 5.318,
    percentChange: 57.6,
  },
  {
    title: 'G Pacific',
    value: 4.196,
    percentChange: 38.4,
  },
  {
    title: 'iPlay',
    value: 3.345,
    percentChange: null,
  },
];

const marketShareSeries = [
  {
    data: [85, 74, 70, 75, 75, 90, 95],
  },
  {
    data: [65, 65, 70, 70, 72, 75, 70],
  },
  {
    data: [35, 44, 50, 55, 55, 60, 65],
  },
  {
    data: [30, 25, 30, 40, 45, 50, 60],
  },
  {
    data: [10, 10, 15, 20, 15, 50, 60],
  },
];

const marketShareTable = [
  {
    title: 'P&G',
    value: 14.585,
    percentChange: 12.8,
  },
  {
    title: 'Kimberly Clark',
    value: 10.314,
    percentChange: -10.1,
  },
  {
    title: 'Amazon',
    value: 5.318,
    percentChange: 0.1,
  },
  {
    title: 'G Pacific',
    value: 4.196,
    percentChange: 0.3,
  },
  {
    title: 'iPlay',
    value: 3.345,
    percentChange: 5.6,
  },
];

export {
  headlineCards,
  watchListCards,
  topPerformersCards,
  heroSeries,
  mySalesSeries,
  mySalesTable,
  myShareSeries,
  myShareTable,
  monthDateRange,
  weekDateRange,
  indexTrendSeries,
  indexTrendTable,
  marketSalesSeries,
  marketSalesTable,
  marketShareSeries,
  marketShareTable,
};
